/**
 * Authenticated fetch wrapper for API Gateway requests.
 * Attaches the Cognito ID token (or session fallback) as a Bearer header.
 */

import { API_GATEWAY_CONFIG } from '../config/apiGatewayConfig';
import { setGlobalTokenGetter } from '../config/apiRouting';

export { setGlobalTokenGetter };

export const authenticatedFetch = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  let token: string | null = null;

  if (API_GATEWAY_CONFIG.tokenGetter) {
    try {
      token = await API_GATEWAY_CONFIG.tokenGetter();
    } catch {
      // Fall through to storage-based token below.
    }
  }

  if (!token) {
    token = sessionStorage.getItem('idToken') || localStorage.getItem('idToken');
  }

  const headers: Record<string, string> = { 'Content-Type': 'application/json' };

  if (options.headers) {
    if (options.headers instanceof Headers) {
      options.headers.forEach((value, key) => { headers[key] = value; });
    } else if (Array.isArray(options.headers)) {
      options.headers.forEach(([key, value]) => { headers[key] = value; });
    } else {
      Object.assign(headers, options.headers);
    }
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return fetch(url, { ...options, headers });
};

export default authenticatedFetch;
